import "./Limits.types";

export type UserLimitBody = Record<`${number}`, Dollars>;

export type UserLimits = Partial<Record<API.Limits.Type, UserLimitBody>>;

// TODO looks like this is a dupe of the same type in byzantine/src/types/index.ts
export type ModelStr =
  | "indigo.Account"
  | "indigo.AchTransfer"
  | "indigo.ACHPaymentViaTemplate"
  | "indigo.ACHPaymentCollectViaTemplate"
  | "indigo.ACHPaymentViaImport"
  | "indigo.ACHPaymentCollectViaImport"
  | "indigo.BulkPaymentTemplateGroup"
  | "integrations.base.Card"
  | "indigo.ExternalAccount"
  | "indigo.IntraInstitutionTransfer"
  | "indigo.MemberFriend"
  | "integrations.base.Payee"
  | "integrations.base.Payment"
  | "indigo.Transaction"
  | "indigo.WireTransaction"
  | "indigo.FedwireTemplate"
  | "indigo.FedwireViaTemplate"
  | "integrations.rdc"
  | "indigo.DualApprovalRequest"
  | "indigo.Organization"
  | "indigo.OrganizationUser"
  | "indigo.Role"
  | "indigo.Recipient"
  | "integrations.documents"
  | "indigo.ACHPayment"
  | "indigo.ACHPaymentCollect"
  | "indigo.ACHImport"
  | "integrations.Zelle"
  | "indigo.SwiftWireTransaction"
  | "indigo.SwiftWireTemplate"
  | "indigo.SwiftWireViaTemplate"
  | "indigo.ACHPaymentReverse"
  | "indigo.ACHPaymentCollectReverse"
  | "indigo.UnverifiedFedNowSend"
  | "indigo.ApproveACHTemplates"
  | "indigo.DomesticWireImport";

export const MODEL_STR_NAMES: Record<string, ModelStr> = {
  ACCOUNT: "indigo.Account",
  ACH_TRANSFER: "indigo.AchTransfer",
  ACH_PAYMENT_VIA_TEMPLATE: "indigo.ACHPaymentViaTemplate",
  ACH_PAYMENT_COLLECT_VIA_TEMPLATE: "indigo.ACHPaymentCollectViaTemplate",
  ACH_PAYMENT_VIA_IMPORT: "indigo.ACHPaymentViaImport",
  ACH_PAYMENT_COLLECT_VIA_IMPORT: "indigo.ACHPaymentCollectViaImport",
  BULK_PAYMENT_TEMPLATE: "indigo.BulkPaymentTemplateGroup",
  CARD: "integrations.base.Card",
  EXTERNAL_ACCOUNT: "indigo.ExternalAccount",
  INTRA_INSTITUTION_TRANSFER: "indigo.IntraInstitutionTransfer",
  MEMBER_FRIEND: "indigo.MemberFriend",
  PAYEE: "integrations.base.Payee",
  PAYMENT: "integrations.base.Payment",
  TRANSACTION: "indigo.Transaction",
  /** @deprecated Use DOMESTIC_WIRE_TRANSACTION instead */
  WIRE_TRANSACTION: "indigo.WireTransaction",
  DOMESTIC_WIRE_TRANSACTION: "indigo.WireTransaction",
  DOMESTIC_WIRE_TEMPLATES: "indigo.FedwireTemplate",
  DOMESTIC_WIRE_VIA_TEMPLATES: "indigo.FedwireViaTemplate",
  RDC: "integrations.rdc",
  DUAL_APPROVAL_REQUEST: "indigo.DualApprovalRequest",
  ORGANIZATION: "indigo.Organization",
  ORGANIZATION_USER: "indigo.OrganizationUser",
  ROLE: "indigo.Role",
  DOCUMENTS: "integrations.documents",
  RECIPIENT: "indigo.Recipient",
  ACH_PAYMENT: "indigo.ACHPayment",
  ACH_PAYMENT_COLLECT: "indigo.ACHPaymentCollect",
  ACH_IMPORT: "indigo.ACHImport",
  ZELLE: "integrations.Zelle",
  INTERNATIONAL_WIRE: "indigo.SwiftWireTransaction",
  INTERNATIONAL_WIRE_TEMPLATES: "indigo.SwiftWireTemplate",
  INTERNATIONAL_WIRE_VIA_TEMPLATES: "indigo.SwiftWireViaTemplate",
  ACH_PAYMENT_REVERSE: "indigo.ACHPaymentReverse",
  ACH_PAYMENT_COLLECT_REVERSE: "indigo.ACHPaymentCollectReverse",
  UNVERIFIED_FEDNOW_SEND: "indigo.UnverifiedFedNowSend",
  APPROVE_ACH_TEMPLATES: "indigo.ApproveACHTemplates",
  DOMESTIC_WIRE_IMPORT: "indigo.DomesticWireImport",
} as const;

export type Operation = "read" | "write" | "*";

export const ROLE_NAMES = {
  ACCOUNT_HOLDER: "Account Holder",
  ADMIN: "Admin",
  COLLABORATOR: "Collaborator",
  VIEWER: "Viewer",
} as const;

export type RoleName =
  | (typeof ROLE_NAMES)[keyof typeof ROLE_NAMES]
  | (string & Record<string, never>);

const ROLE_DESCS = {
  ACCOUNT_HOLDER: "Primary account holder",
  ADMIN: "Full access including adding new users",
  VIEWER: "Limited access with no ability to move money",
  COLLABORATOR: "Customize your teammate's access",
} as const;

// Custom roles have null descriptions
export type RoleDescription =
  | (typeof ROLE_DESCS)[keyof typeof ROLE_DESCS]
  | null;

declare global {
  namespace API {
    type RoleId = Brand<string, "RoleId">;

    interface Role {
      uuid: API.RoleId;
      organization_uuid: API.OrganizationId;
      name: RoleName;
      description: RoleDescription;
      permissions: Permission[];
      limits: UserLimits;
    }
  }
}

export type OrgRolesPayload = {
  roles: API.Role[];
};
